import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
var styles = xcss({
  boxShadow: 'elevation.shadow.overflow',
  width: '340px',
  padding: 'space.200',
  borderRadius: 'border.radius',
  backgroundColor: 'elevation.surface.overlay'
});
export var MediaInsertWrapper = function MediaInsertWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles
  }, children);
};